import { defineComponent, ref } from 'vue'
import { useStore } from './state'

export default defineComponent({
  name: 'agreeDetail',
  setup (_, { expose }) {
    const store = useStore()

    const 동의칸 = ref<HTMLInputElement>()
    const 이름칸 = ref<HTMLInputElement>()
    expose({
      scroll: () => {
        이름칸.value.scrollIntoView({
          behavior: 'smooth',
        })
      },
    })

    return () => (
      <div>
        <div class="font-bold text-xl">연구대상자 설명문</div>
        <br />
        <div class="font-bold">1. 임상연구 제목</div>
        <div class="first-letter:ml-4">
          디지털 정신건강 모니터링 시스템 개발 및 검증
        </div>
        <br />
        <div class="font-bold">2. 연구책임자</div>
        <div class="first-letter:ml-4">
          서울대학교병원 정신건강의학과 교수 신민섭
        </div>
        <br />
        <div class="font-bold">3. 임상연구의 배경 및 목적</div>
        <div class="first-letter:ml-4">
          최근 정신건강 케어에 대한 수요가 꾸준히 늘어나고 있지만, 양질의
          정신건강 케어 서비스를 제공할 수 있는 전문인력의 수가 현저히 부족하고
          높은 치료 비용, 긴 대기 시간, 낙인 효과에 대한 염려로 인해 치료 기관에
          대한 접근이 어려운 상황입니다. 이를 개선하기 위해 비대면, 온라인을
          활용한 웹/모바일 기반 프로그램을 도입하려는 노력이 지속되고 있습니다.
          그러나 현재 제공되고 있는 기존의 프로그램들은 특정 장애에 한정되어
          있는 경우가 많으며, 참여자 개인의 성격, 특성을 충분히 고려하지
          못한다는 한계가 있습니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          따라서 타당한 심리검사를 통해 개인의 성격을 파악하여 유형화하고, 이를
          고려한 비대면, 온라인 심리 치료 서비스를 제공하는 서비스가 필요합니다.
          이 연구에서는 이러한 서비스 제공을 목표로 하는 디지털 정신건강
          모니터링 시스템인 ‘마인들링(MINDLiNG)’과 관련하여 스키마 검사를 활용한
          치유 프로그램의 개발 및 효과성 검증을 수행하고자 합니다. 귀하는 스키마
          검사를 비롯한 여러 측정 도구 및 치유 프로그램 안내를 충분히 이해하고
          응답할 수 있는 만 18세 이상 60세 미만의 성인이기 때문에 이 연구에
          참여할 수 있습니다. 이 연구를 수행하는 서울대학교 소속의 김현성
          연구원, 정서현 연구원(사무실 02-2072-0725)이 귀하에게 이 연구에 대한
          설명문을 제공할 것입니다. 이 연구는 자발적으로 참여 의사를 밝히신 분에
          한하여 수행될 것이며, 귀하께서는 참여 의사를 결정하기 전에 본 연구가
          왜 수행되는지 그리고 연구의 내용이 무엇과 관련 있는지 이해하는 것이
          중요합니다. 다음 내용을 신중히 읽어보신 후 참여 의사를 밝혀 주시길
          바라며, 필요하다면 가족이나 친구들과 의논해 보십시오. 만일 어떠한
          질문이 있다면 담당 연구원(김현성, 정서현, 02-2072-0725)과의 연락을
          통해 자세하게 설명 받을 수 있습니다.
        </div>
        <br />
        <div class="font-bold">4. 임상연구 참여대상자 수 및 참여기간</div>
        <div class="first-letter:ml-4">
          만 18세 이상, 만 60세 미만의 성인 중 인터넷 커뮤니티 사이트를 통해
          모집된 참여자 또는 스키마 검사 타당화 연구에서 후속 연구에 대한 참가를
          신청한 참여자 총 300명이 참여합니다. 이후 온라인 치유프로그램에 참여
          혹은 대기 통제는 약 10주간 진행(연구 종료 1개월 후 설문 제출까지 포함
          시 약 14주)되며, 최대 4차례(치유 프로그램 시작 시, 프로그램 5주차 완료
          시, 종료 시, 종료 1개월 후)에 걸쳐 온라인으로 설문지를 제출하게
          됩니다.
        </div>
        <br />
        <div class="font-bold">5. 임상연구의 절차 및 방법</div>
        <div class="first-letter:ml-4">
          만일 귀하가 연구 참여에 동의한다는 의미로 하단의 ‘동의합니다’에
          표시해주시면, 다음과 같은 과정이 진행될 것입니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          ① 다음 페이지에서 안내에 따라 온라인 사전설문지에 응답하실 수
          있습니다. 사전설문지는 통계적 분석을 위해 최소한의 개인정보(성별,
          나이, 교육년수, 직업군, 결혼 여부)를 수집합니다. 또한 사전설문지는
          스키마 검사, 지각된 스트레스 척도, 완벽주의, 불안 성향 등의 심리적
          특성과 관련된 질문들로 구성되어 있습니다. 이러한 질문에 대한 응답은
          연구 분석을 위해 활용될 수 있습니다.
        </div>
        <div class="first-letter:ml-4">
          ② 사전 설문을 마친 뒤 연구 참여 가능 여부를 결정하기 위해 면담(전화
          또는 이메일 등)을 진행하게 됩니다. 면담의 대상자에 해당되는지는 설문지
          맨 마지막 페이지를 통해 확인하실 수 있습니다. 면담은 사전 설문을 마친
          뒤 1-2주 내에 진행되며, 입력해주신 연락처로 연구원이 연락을 드릴
          예정입니다. 사전 설문에서 면담의 대상에 부합되지 않을 경우, 더 이상
          연구에 참여하실 수 없습니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          ③ 면담 결과, 연구 참여 대상자에 해당되는 경우 연구에 최종적으로
          참여하실 수 있게 됩니다. 연구 참여 대상자가 되면, 본 동의서에 대해
          별도로 전자동의절차를 통해 전자 서명을 하게 됩니다. 면담에서 연구 참여
          대상자에 부합되지 않을 경우 더 이상 연구에 참여하실 수 없으며, 본
          동의서에 대해 따로 전자동의절차를 통해 전자 서명을 하지 않습니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          ④ 이후 연구 참여 대상자는 연구 일정에 따라 요청된 기한에 스키마 검사
          등이 포함된 온라인 설문을 진행하고, 무선 배정된 집단에 따라 약 10주 간
          온라인 치유 프로그램을 수행하거나 동일한 기간 동안 대기하게 됩니다.
          치유 프로그램을 실시하는 참여자의 경우, 프로그램은 매일 원하는
          시간대에 진행될 수 있으나 일관된 시간대에 프로그램 권장 진도에 따라
          진행하기를 안내 드립니다. 또한 프로그램 5주차 완료 시점 및 종료 시점에
          동일한 온라인 설문을 각 1회 더 시행하며, 프로그램 종료 1개월 후에
          동일한 온라인 설문을 1회 추가 실시하게 됩니다. 이 과정에서 치유
          프로그램 및 설문이 온라인으로 진행되어 사용 방법이 미숙하거나 참여가
          부진할 경우 참여 격려를 위해 휴대폰 메시지, 전화 등을 통해 연락이
          이루어질 수 있습니다. 아울러 대기 집단으로 분류된 참여자분들은 연구
          시작 시점으로부터 10주 뒤에 온라인 설문 응답을 완료하면 치유
          프로그램에 참여하실 수 있습니다.
        </div>
        <br />
        <div class="font-bold">
          6. 연구대상자에게 예견되는 부작용, 위험과 불편함
        </div>
        <div class="first-letter:ml-4">
          본 연구는 온라인 설문을 통한 평가와 치유 프로그램 참여 두 부분으로
          구성되어 있습니다. 온라인 설문은 귀하의 심리적 특성을 알아보는
          문항으로 구성되어 있어 귀하에게 해가 될 수 있는 물리적 위험요소는
          존재하지 않습니다. 또한, 본 연구에서 제공하는 치유 프로그램은 검증되지
          않은 임상시험이나, 정신건강케어를 위한 내용으로 구성되어 있어 귀하에게
          해가 될 수 있는 물리적 위험요소는 존재하지 않습니다.{' '}
        </div>
        <br />
        <div class="font-bold">7. 연구대상자에게 예견되는 이득</div>
        <div class="first-letter:ml-4">
          연구 참여 대상자에 해당될 경우, 디지털 정신건강 모니터링 시스템
          ‘마인들링(MINDLiNG)’을 무료로 이용할 수 있는 기회를 제공받습니다. 또한
          다음과 같이 소정의 사례금을 지급(계좌이체) 받게 됩니다. 먼저, 연구
          참여 시 첫번째 온라인 설문조사에 응답하시면 1만원의 사례금을 지급받을
          수 있으며, 5주 경과 후, 10주 경과 후 추가적으로 온라인 설문을 제출한
          경우 각 1만원의 사례금을 지급받을 수 있습니다. 마지막으로 프로그램
          종료 4주 경과 후 마지막 설문조사에 응답하는 집단에 속하였을 경우,
          마지막 설문조사를 마친 뒤 1만원의 사례금을 지급받을 수 있습니다.
          설문조사 1회를 완료할 때마다 1만원의 보상(최대 4만원)을 받을 수
          있으며, 모든 사례금은 연구가 종료되는 1-2월에 지급될 수 있습니다.
        </div>
        <br />
        <div class="font-bold">8. 연구 참여 비용 및 손실에 대한 보상</div>
        <div class="first-letter:ml-4">
          본 연구에 참여하는 비용은 무료입니다. 또한 연구를 완료하지 않고 그만둘
          경우 연구와 관련된 손실에 대해 별도로 보상을 청구하지 않습니다.{' '}
        </div>
        <br />
        <div class="font-bold">9. 자발적 참여 및 동의 철회</div>
        <div class="first-letter:ml-4">
          귀하는 본 연구에 어디까지나 자발적인 의사에 따라 참여를 결정할 수
          있습니다. 또한 귀하가 본 연구에 참여하더라도 언제든지 참여를 취소 및
          중단할 수 있으며, 참여 취소 및 중단, 연구 불참으로 인한 어떠한
          불이익도 없습니다.
        </div>
        <br />
        <div class="font-bold">
          10. 개인정보보호 및 개인정보 제공에 관한 사항
        </div>
        <div class="first-letter:ml-4">
          본 연구에서는 연구자료로서 귀하의 개인정보인 성별, 나이, 교육년수,
          직업군, 결혼여부를 수집하며, 연구 진행(사례금 지급 등)을 위해서 이메일
          주소, 주민등록번호, 개인 연락처, 계좌번호, 통장사본 이미지를 수집하게
          됩니다. 먼저, 연구자료로서 수집하는 개인정보인 성별, 나이, 교육년수,
          직업군은 통계분석을 위해서만 수집됩니다. 이는 추후 연구 결과를
          발표하기 위한 목적으로 공개된 데이터베이스에 등록될 수도 있으나,
          귀하의 개인 신상 확인이 불가능하도록 처리(익명화)됩니다. 다음으로
          이메일 주소는 설문조사를 진행하는 사이트 주소와 아이디, 패스워드를
          발급하기 위해 수집하며, 주민등록번호, 개인 연락처, 계좌번호, 통장사본
          이미지는 사례금 지급과 사례비 지급에 대한 증빙을 목적으로 수집합니다.
          이러한 개인정보는 연구에서 제공하게 될 온라인 설문 내용과 연계되지
          않으며, 개인정보 수집 목적을 달성한 후에 삭제됩니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          이러한 개인정보는 연구책임자 및 연구담당자에게만 접근이 허락되며,
          개인신상정보를 연구 목적 이외에 사용하거나 본 연구진 이외의 제3자에게
          연구대상자의 사전 동의 또는 요청 없이 고지하거나 열람 및 복사할 수
          없도록 보안된 USB데이터 폴더에 따로 보관합니다. 연구책임자와
          연구담당자는 이 연구를 통해 얻은 모든 개인 정보의 비밀 보장을 위해
          최선을 다할 것입니다. 이 연구에서 얻어진 개인 정보가 학회지나 학회에
          공개될 때 귀하의 이름 및 기타 개인 정보는 사용되지 않을 것입니다.
          그러나 모니터 요원, 점검 요원, 생명윤리위원회는 연구참여자의 개인
          정보에 대한 비밀 보장을 침해하지 않고 관련 규정이 정하는 범위 안에서
          본 연구의 실시 절차와 자료의 신뢰성을 검증하기 위해 연구 결과를 직접
          열람할 수 있습니다. 동의서는 관련 법령에 따라 3년을 보관한 후 폐기할
          예정이며, 연구자료의 경우는 서울대학교 연구윤리 지침에 따라 가능한
          영구 보관할 예정입니다. 또한 연구 결과는 궁극적으로 본 과제를 위탁한
          주관기관인 ㈜포티파이에 제공될 수 있고, 연구 결과는 상업적 목적으로
          이용될 수 있습니다. 본 연구에 참여하기로 동의하는 것은 향후 이러한
          사용에 동의하는 것입니다. 하지만, 제공되는 연구 결과에는 개인 신상
          확인이 불가능하도록 익명화되어 처리되어 개인을 식별할 수 없습니다.{' '}
        </div>
        <div class="first-letter:ml-4">
          귀하가 본 동의서를 수락한다는 것은, 개인정보보호 및 개인정보 제공에
          관한 사항에 대하여 사전에 알고 있었으며 이를 허용한다는 동의로 간주될
          것입니다.{' '}
        </div>
        <br />
        <br />
        <div class="font-bold">11. 담당자 연락처</div>
        <div class="first-letter:ml-4">
          본 연구에 대해 질문이 있거나 연구 중간에 문제가 생길 시 다음 연구
          담당자에게 연락하십시오.
        </div>
        <br />
        <div>
          이름 : 김현성, 정서현 전화번호 : 02-2072-0725 이메일 : 5C483@snuh.org,
          5C484@snuh.org{' '}
        </div>
        <br />
        <div class="first-letter:ml-4">
          만일 어느 때라도 연구참여자로서 귀하의 권리에 대한 질문이 있다면
          다음의 서울대학교 의학연구윤리심의위원회 또는 임상연구윤리센터에
          연락하십시오.{' '}
        </div>
        <br />
        <div>기관명 : 의학연구윤리심의위원회(IRB) 전화번호 : 02-2072-0694 </div>
        <div>기관명 : 임상연구윤리센터 전화번호 : 02-2072-3509</div>
        <br />
        <div>
          본인은 임상연구에 대해 상기 연구 설명문을 읽었으며, 이 연구에 참여하는
          것에 대하여 자발적으로…
        </div>
        <div ref={동의칸}>
          <div class="cursor-pointer">
            <input
              type="checkbox"
              id="agree"
              checked={store.agree === true}
              onInput={(e) => {
                const target = e.target as HTMLInputElement
                if (target.checked) {
                  store.agree = true
                }
              }}
            />
            <label for="agree" class="ml-2">
              동의합니다.
            </label>
          </div>
          <div class="cursor-pointer">
            <input
              type="checkbox"
              id="disagree"
              checked={store.agree === false}
              onInput={(e) => {
                const target = e.target as HTMLInputElement
                if (target.checked) {
                  store.agree = false
                }
              }}
            />
            <label for="disagree" class="ml-2">
              동의하지 않습니다.
            </label>
          </div>
        </div>
        <div class="mt-16 text-xl font-bold">연구대상자 동의서</div>
        <br />
        <div>
          1. 본인은 임상연구에 대해 상기 연구 설명문을 읽었으며 담당 연구원과 이
          연구에 대하여 충분히 의논하였습니다.
        </div>
        <div>
          2. 본인은 연구의 위험과 이득에 관하여 설명 들었으며 나의 질문에 만족할
          만한 답변을 얻었습니다.
        </div>
        <div>
          3. 본인은 이 연구에 참여하는 것에 대하여 자발적으로 동의합니다.
        </div>
        <div>
          4. 본인은 이후의 치료에 영향을 받지 않고 언제든지 연구의 참여를
          거부하거나 연구의 참여를 중도에 철회할 수 있고 이러한 결정이 나에게
          어떠한 해가 되지 않을 것이라는 것을 알고 있습니다.
        </div>
        <div>
          5. 본인은 이 설명서 및 동의서에 서명함으로써 의학 연구 목적으로 나의
          개인정보가 현행 법률과 규정이 허용하는 범위 내에서 연구자가 수집하고
          처리하는데 동의합니다.
        </div>
        <div>
          6. 본인은 연구 설명문 및 동의서의 사본을 받을 것을 알고 있습니다.
        </div>
        <div>
          7. 위 내용을 숙지하였으며, 본 연구에 참여하시겠으면 하단에 성함을 적어
          주시기 바랍니다.{' '}
        </div>
        <br />
        <br />
        <div class="text-center" ref={이름칸}>
          성 명 :{' '}
          <input
            class="min-w-[200px] p-2 border-b border-black"
            value={store.name}
            onInput={(e) => {
              store.name = (e.target as HTMLInputElement).value.trim()
            }}
          />{' '}
          (인)
        </div>
      </div>
    )
  },
})
